const ShopChatComponent = () => import('@/views/shop/ShopChat/ShopChatView')

export default [
    {
        path:'/ShopChatIndex',
        name:'ShopChatRouter',
        component:ShopChatComponent
    }
]